import React from "react";
import PropTypes from "prop-types";
import { CardBoxElement } from "./CardBox.styles";

const CardBox = props => <CardBoxElement {...props}>{props.children}</CardBoxElement>;

CardBox.propTypes = {
  children: PropTypes.node.isRequired,
  display: PropTypes.string,
  flexDirection: PropTypes.string,
  justifyContent: PropTypes.string,
  paddingTop: PropTypes.number,
  paddingBottom: PropTypes.number,
  paddingRight: PropTypes.number,
  paddingLeft: PropTypes.number,
  marginLeft: PropTypes.number,
  marginRight: PropTypes.number,
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  boxShadow: PropTypes.bool,
  boxShadowHard: PropTypes.bool,
  alignItems: PropTypes.string,
};

CardBox.defaultProps = {
  display: "inline-flex",
  flexDirection: "column",
  paddingTop: 20,
  paddingBottom: 20,
  paddingRight: 23,
  paddingLeft: 23,
  justifyContent: "flex-start",
  alignItems: null,
  marginLeft: 10,
  marginRight: 10,
  marginTop: 10,
  marginBottom: 10,
  minWidth: 0,
  maxWidth: undefined,
  boxShadow: true,
  boxShadowHard: false,
};

export default CardBox;
